module.exports = __webpack_public_path__ + "static/media/transfer-SCHEDULED.919ed443.svg";